export default {
  errors: {
    db_query_failed: "เชื่อมต่อฐานข้อมูลผิดพลาด",
    db_fetch_failed: "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
    permission_denied: "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
    invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
    invalid_parameter: "ข้อมูลที่ระบุไม่ถูกต้อง",
    duplicate_tax_id: "หมายเลขผู้เสียภาษีซ้ำ",
	date_wrong_format:"รูปแบบวันที่ไม่ถูกต้อง",
	transaction_not_finish:"รายการขายยังไม่สำเร็จ",
	duplicated_policy_number:"หมายเลยกรมธรรม์ซ้ำ",
    user: {
      duplicate: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_username: "ข้อมูลผู้ใช้งานซ้ำ",
      duplicate_email: "ข้อมูลอีเมล์ซ้ำ",
      blcok_delete_by_self: "ไม่สามารถลบข้อมูลตนเองได้",
      fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
      email_wrong_format: "รูปแบบอีเมล์ไม่ถูกต้อง",
      enterprise_empty: "กรุณาระบุองค์กร"
    },
    auth: {
      login_fail: "เข้าสู่ระบบผิดพลาด",
      block: "ผู้ใช้งานถูกระงับ",
      login_success: "เข้าสู่ระบบสำเร็จ",
      logout_success: "ออกจากระบบสำเร็จ",
      unauthoriezed: "เข้าสู่ระบบผิดพลาด",
      reset_invalid_token: "token ไม่ถูกต้อง",
      reset_token_expired: "token หมดอายุ",
      forgot_password_fail: "ลืมรหัสผ่านไม่สำเร็จ",
      reset_password_fail: "เปลี่ยนรหัสผ่านไม่สำเร็จ",
      username_wrong_format: "รูปแบบของชื่อผู้ใช้งานไม่ถูกต้อง",
      password_wrong_format: "รูปแบบของรหัสผ่านไม่ถูกต้อง",
      token: "Toekn ไม่ถูกต้อง",
      password: "รหัสผ่านไม่ถูกต้อง",
      password_confirm: "การยืนยันรหัสผ่านไม่ถูกต้อง"
    },
    profile: {
      change_profile_failed: "แก้ไขข้อมูลผิดพลาด",
      change_password_failed: "แก้ไขรหัสผ่านผิดพลาด",
      password_confirm_not_match: "การยืนยันรหัสผ่านไม่ถูกต้อง",
      password_confirm_wrong_format: "รูปแบบรหัสผ่านไม่ฟถูกต้อง",
      password_old_wrong: "รหัสผ่านเดิมไม่ถูกต้อง"
    },
  },


  profile: {
    profile: "ข้อมูลส่วนตัว",
    birthday: "วันเกิด",
    name: "ชื่อ",
    pname: "คำนำหน้าชื่อ",
    fname: "ชื่อ",
    lname: "นามสกุล",
    phone: "เบอร์โทรศัพท์",
    email: "อีเมล์",
    change_password: "เปลี่ยนรหัสผ่าน",
    password: "รหัสผ่าน",
    password_old: "รหัสผ่านเดิม",
    password_new: "รหัสผ่านใหม่",
    password_confirm: "ยืนยันรหัสผ่าน",
    change_profile_success: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
    change_password_success: "เปลี่ยนรหัสผ่านสำเร็จ",
    type: "ประเภทผู้ใช้งาน",
    gender: "เพศ",
    cardid: "เลขบัตรประจำตัวประชาชน",
    create: "สร้างผู้ใช้งาน",
    change_password: "แก้ไขรหัสผ่าน",
    change_status: "แก้ไขสถานะ",
  },
  menu: {
    user: "ผู้ใช้งาน",
    bank: "บัญชีธนาคาร",
    billing: "รายการเรียกเก็บเงิน",
    billing_report: "รายการเรียกเก็บเงิน",
    invoice: "รายการวางบิล",
    branch: "สาขา",
    insure: "ประเภทประกันภัย",
    comm: "คอมมิชชั่น",
    comm_extra: "รายการประเภทประกัน",
    payment: "รายการชำระเงิน",
    ttype: "ช่องทางการขาย",
    person: "ตัวแทน",
    trans: "รายการขาย",
    trans_cancel: "รายการขายที่ยกเลิก",
    customer: "ลูกค้า",
    cash_clear: "บันทึกการรับเงินสด",
    setting: "ตั้งค่า",
    admin: "ผู้ดูแล",
    database: "ฐานข้อมูล",
    wht: "ใบหักภาษี ณ ที่จ่าย",
  },
  auth: {
    signin: "เข้าสู่ระบบ",
    signout: "ออกจากระบบ",
    username: "อีเมล์หรือชื่อผู้ใช้งาน",
    email: "อีเมล์",
    block: "ผู้ใช้งานนี้ถูกปิด",
    password: "รหัสผ่าน",
    forgetpassword: "ลืมรหัสผ่าน",
    resetpassword: "รีเซ็ตพาสเวิร์ด",
    confirm_reset_password: "ยืนยันการรีเซ็ตพาสเวิร์ดหมายเลข ",
    forgot_password_success: "ลืมรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมล์",
    reset_password_success: "เปลี่ยนรหัสผ่านสำเร็จ"
  },
  user: {
    create: "สร้างผู้ใช้งาน",
    name: "ชื่อ",
    username: "ชื่อผู้ใช้",
    phone: "เบอร์โทรศัพท์",
    role: "ระดับผู้ใช้งาน",
    type: "ประเภทผู้ใช้งาน",
    create_success: "สร้างผู้ใช้งานสำเร็จ",
    create_fail: "สร้างผู้ใช้งานไม่สำเร็จ"
  },
  name: "ชื่อ",
  description: "คำอธิบาย",
  location_x: "ตำแหน่ง (X)",
  location_y: "ตำแหน่ง (Y)",
  group_name: "ชื่อกลุ่ม",
  email: "อีเมล์",
  email_optional: "อีเมล์ (ไม่ระบุ)",
  created: "วันที่สร้าง",
  search: "ค้นหา",
  searchall: "ค้นหาทั้งหมด",
  save: "บันทึก",
  save_continue: "บันทึกต่อเนื่อง",
  back: "กลับ",
  new: "สร้าง",
  status: "สถานะ",
  download: "ดาวน์โหลด",
  downloadall: "ดาวน์โหลดทั้งหมด",
  product_search: "ค้นหาสินค้า",
  welcome: "ยินดีต้อนรับ",
  myprofile: "ข้อมูลส่วนตัว",
  changepassword: "เปลี่ยนรหัสผ่าน",
  page_notfound: "ขออภัย ไม่พบหน้าที่คุณต้องการ",
  page_notfound_desc:
    "หน้าดังกล่าวอาจมีการเปลี่ยนแปลง ชื่อ หรือ URL ไม่ถูกต้อง กรุณาตรวจสอบลิงค์ที่คุณเข้ามาอีกครั้ง",
  actions: "เมนู",
  detail: "รายละเอียด",
  data: "ข้อมูล",
  to: "ถึง",
  of: "จาก",
  row_select: "ข้อมูลที่ถูกเลือก",
  yes: "ใช่",
  no: "ไม่ใช่",
  ok: "ตกลง",
  cancel: "ยกเลิก",
  upload_file: "เพิ่มไฟล์",
  bg_admin: "ตั้งค่าผู้ดูแลระบบ",
  comportal: "ตั้งค่าผู้ใช้งาน",
  add: "เพิ่ม",
  close: "ปิด",
  please_select: "กรุณาเลือก",
  create: "สร้าง",
  confirm: "ยืนยัน",
  create_success: "สร้างข้อมูลสำเร็จ",
  delete_confirm: "ยืนยันการลบข้อมูล",
  delete_confirm_text: "คุณต้องการลบข้อมูล ",
  delete_confirm_question: "คุณต้องการลบข้อมูล ",
  delete_success: "ลบข้อมูลสำเร็จ",
  delete_fail: "ลบข้อมูลไม่สำเร็จ",
  cancel_confirm: "ยืนยันการยกเลิกข้อมูล",
  cancel_confirm_text: "คุณต้องการยกเลิกข้อมูล ",
  cancel_confirm_question: "คุณต้องการยกเลิกข้อมูล ",
  cancel_success: "ยกเลิกข้อมูลสำเร็จ",
  cancel_fail: "ยกเลิกข้อมูลไม่สำเร็จ",
  edit_success: "แก้ไขข้อมูลสำเร็จ",
  edit_fail: "แก้ไขข้อมูลไม่สำเร็จ",
  created_at : "วันที่สร้าง",

  status_active: "ใช้งาน",
  status_not_active: "ไม่ใช้งาน",

    fname: "ชื่อ",
    lname: "นามสกุล",
    birthday: "วันเกิด",
    // Action
    create : "สร้าง",
    delete : "ลบ",
    edit : "แก้ไข",

    InsureLevel : "ระดับประกันภัย",
    InsureUpper : "กลุ่มประกันภัย",
  lmg: {
    extra_charge: "เก็บเพิ่มเติม",
	address_customer:"ที่อยู่",
	address_province:"จังหวัด",
	address_district:"อำเภอ",
	address_subdistrict:"ตำบล",
	address_zipcode:"รหัสไปรษณีย์",

    wht: "ใบหักภาษี ณ ที่จ่าย",
    name: "Lmg",
    code: "โค้ด",
    bank: "บัญชีธนาคาร",
    branch: "สาขา",
    comm: "คอมมิชชั่นโปรไฟล์",
    comm_extra: "รายการประเภทประกัน",
    insure: "ประกันภัย",
    insure_type: "ประเภทประกันภัย",
    insure_plan: "แผน",
    data_type: "ชนิดข้อมูล",
    insure_data_type: "ประเภทข้อมูล",
    insure_data_type_1: "ประกันรถยนต์",
    insure_data_type_2: "ประกันสุขภาพ",
    insure_data_type_3: "ประกันวินาศภัย (อาคาร)",
    insure_data_type_4: "ประกันวินาศภัย (ขนส่ง)",
    insure_data_type_5: "ประกันเบ็ดเตล็ด",
    person: "ตัวแทน",
    ttype: "ช่องทางการขาย",
    user: "ผู้ใช้งาน",
    customer: "ลูกค้า",
    trans: "รายการขาย",
    billing: "การเรียกเก็บเงิน",
    sale_date: "วันที่ขาย",

    detail: "ค่าเสียหายส่วนแรก (DD)",

    // Bank
    bank_name: "ชื่อธนาคาร",
    bank_account: "เลขบัญชีธนาคาร",
    bank_code: "รหัสสาขา",

    // Person
    agent_code: "รหัสตัวแทน",
    with_holding_tax: "ณ ที่จ่าย",
    tel: "โทรศัพท์",
    email: "อีเมล์",
    address: "ที่อยู่",
    subdistrict: "ตำบล",
    city: "อำเภอ",
    province: "จังหวัด",
    postcode: "รหัสไปรษณีย์",

    card_type: "ประเภทบัตร",
    card_type_1: "บัตรประชาชน",
    card_type_2: "Passport",
    card_type_3: "นิติบุคคล",
  

    // transaction
    transaction_id: "หมายเลขการขาย",
    cancel_trans: "ยกเลิกรายการขาย",
    trans_create: "สร้างรายการขาย",
    trans_detail: "ข้อมูลรายการขาย",
    trans_report_discount: "ใบจ่ายส่วนลด",
    discount : "ส่วนลด",
    moreDiscount : "ส่วนลดพิเศษ",
    trans_report: "รายงานการขาย",
    // User
    user_type: "ประเภทผู้ใช้งาน",


    // Billing
    billing : "รายการเรียกเก็บเงิน",
    billing_bill_id : "หมายเลขการเรียกเก็บเงิน",
    billing_paid_via : "วิธีชำระเงิน",
    billing_note : "หมายเหตุ",
    note : "หมายเหตุ",
    billing_period : "แบ่งชำระ",
    payment : "ชำระเงิน",
    paid_type_cash : "เงินสด",
    paid_type_check : "เช็ค",
    paid_type_transfer : "โอนเงิน",
    paid_file : "หลักฐานการชำระเงิน",
    paid_status : "สถานะการชำระเงิน",
    paid_time : "เวลาที่ชำระเงิน",

    recorder: "ผู้บันทึก",
    due_date: "วันครบกำหนดชำระ",
    amount: "จำนวนเงิน",
	invoice_amount_all:"เบี้ยรวม",
	invoice_amount:"เบี้ยสุทธิ",
	invoice_pay_amount:"ยอดรวมชำระ",

    sort : "เรียงลำดับ",

    // Comm
    comm_incentive: "ค่าส่งเสริม (บาท)",
    comm_limitCnt: "จำกัด (ครั้งต่อปี)",
    comm_amount: "ค่าคอมมิชชั่น",
    comm_adjust: "ค่าคอมมิชชั่นพิเศษ",
    comm_amount_percent: "ค่าคอมมิชชั่น (%)",
    change_credit_limit: "แก้ไขวงเงิน",
    credit: "เครดิต",
    credit_limit: "วงเงิน",
    credit_temp: "วงเงินชั่วคราว",
    credit_range: "ระยะเวลาเครดิต (วัน)",

    person_upper: "หัวหน้าทีม",
    person_type: "ช่องทางการขาย",
    owner_person: "ตัวแทนประกันภัย",
    policy_number: "หมายเลขกรมธรรม์",
    license_plate: "ทะเบียนรถ",


    // Person
    taxid: "หมายเลขผู้เสียภาษี",
    postcode: "รหัสไปรษณีย์",
    protection_date: "ระยะเวลาคุ้มครอง",

    cid: "หมายเลขบัตรประจำตัวประชาชน / Passport",
    payment_method: "ช่องทางชำระเงิน",
    payment_amount: "จำนวนเงินที่ชำระไว้แล้ว",
    trans_payment_amount: "จำนวนเงินที่ต้องชำระ",
    payment_comm: "ค่าคอมมิชชั่นที่หักไว้แล้ว",
    payment_date: "วันที่ชำระเงิน",
    payment_create: "สร้างรายการชำระเงิน",
    payment_image: "หลักฐานการชำระเงิน",
    policy_start_date : "เริ่มการคุ้มครอง",
    policy_end_date : "สิ้นสุดการคุ้มครอง",

    trans_amount: "เบี้ยสุทธิ",
    summary_amount: "เบี้ยรวม",
    trans_date: "วันที่บันทึก",
    cash_clear: "เงินค้างที่พนักงาน",
    cash_clear_title: "บันทึกการรับเงินสดจากพนักงาน",
    cash_clear_date: "วันที่รับเงินจากพนักงาน",
    cash_clear_recorder: "ผู้บันทึกการรับเงินจากพนักงาน",
    cash_clear_amount: "จำนวนเงินค้างที่พนักงาน",
    cash_out_branch: "นำเงินออกจากสาขา",


    insure_year: "ปีที่ทำ",
    trans_detail: "รายการ",
    age: "อายุ",
    insure_sum: "ทุนประกัน",
    car_model: "รุ่นรถ",
    car_year: "ปีรถ",
    billing_address : "สถานที่ตั้ง",
    code_disaster : "รหัสภัย",
    chassis_number : "รหัสตัวถัง",
    insurance_scope : "ขอบเขต",


    pay_amount : "ยอดรวมชำระ",
    tax_amount : "ภาษีส่วนลด",
    net_amount : "คงเหลือ",
    commission_discount : "หักส่วนลด",
    billCharge : "ชาร์จต่องวด",
    renew : "ต่ออายุ",
    policyNumberUpper : "หมายเลขกรมธรรม์เดิม",
    whTax : "ณ ที่จ่าย",
    invoice : "รายการวางบิล",
    invoice_number : "หมายเลขวางบิล",
    back : "กลับ",
    date : "วันที่",


	book_id:"เล่มที่",
	number_id:"เลขที่",
	start_date:"วันที่เริ่มต้น",
	end_date:"วันที่สิ้นสุด",
	effect_date:"วันที่มีผล",
	car_type:"ประเภทรถยนต์",
	refund_amount:"คืนเบี้ยสุทธิ",
	refund_amount_all:"คืนเบี้ยรวม",
	per_page : "จำนวนรายการต่อหน้า",
  }
};
